/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/upgrade_xp': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646L31.354 16 28 12.646zm-24 6L1.354 16 4 13.354v5.292zM16 1.354L18.646 4h-5.293L16 1.354zm0 29.292L13.354 28h5.292L16 30.646zm3.354-12a.5.5 0 01-.708.708L16 16.707l-2.646 2.646a.5.5 0 11-.708-.706L15.293 16l-2.646-2.646a.5.5 0 01.707-.707L16 15.293l2.646-2.646a.5.5 0 01.707.707L16.707 16l2.647 2.646zM28 13.353L30.646 16 28 18.646v-5.293z"/>'
  }
})
